import { useCallback, useEffect, useRef, useState } from 'react';
import type { OpenedOrderAcceptance } from './jobCard.service';
import { revokeOrderAcceptanceUrl } from './jobCard.service';

export function useOpenedOaPreview() {
  const [preview, setPreview] = useState<OpenedOrderAcceptance | null>(null);
  const [openingId, setOpeningId] = useState<string | null>(null);
  const urlRef = useRef<string | null>(null);

  const close = useCallback(() => {
    if (urlRef.current) {
      revokeOrderAcceptanceUrl(urlRef.current);
      urlRef.current = null;
    }
    setPreview(null);
  }, []);

  useEffect(() => () => {
    if (urlRef.current) revokeOrderAcceptanceUrl(urlRef.current);
  }, []);

  const openFile = useCallback(async (
    id: string,
    loader: () => Promise<OpenedOrderAcceptance>,
  ) => {
    setOpeningId(id);
    try {
      if (urlRef.current) {
        revokeOrderAcceptanceUrl(urlRef.current);
        urlRef.current = null;
      }
      const next = await loader();
      urlRef.current = next.url;
      if (next.kind === 'other') {
        const tab = window.open(next.url, '_blank', 'noopener,noreferrer');
        if (tab) {
          window.setTimeout(() => {
            if (urlRef.current === next.url) {
              revokeOrderAcceptanceUrl(next.url);
              urlRef.current = null;
            }
          }, 120_000);
          return;
        }
      }
      setPreview(next);
    } finally {
      setOpeningId(null);
    }
  }, []);

  return { preview, openingId, openFile, close };
}
